// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--2IpcU";
export var content = "Layout-module--content--2eUHp";
export var contentWithAnnouncement = "Layout-module--contentWithAnnouncement--3fcdp";
export var contentWithAnnouncementMobile = "Layout-module--contentWithAnnouncementMobile--EDJvG";
export var banner = "Layout-module--banner--vPEeA";
export var bannerContent = "Layout-module--bannerContent--3UM9v";
export var errorBoundary = "Layout-module--errorBoundary--1i7Xm";